import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { SSRPlaceholder } from '../../SSRPlaceholder';
import { range } from 'lodash';
import { ComponentJSSClasses } from './styles';

export interface ReviewsPlaceholderProps { }

interface StyledReviewsPlaceholderProps extends JSSClassesProps<ComponentJSSClasses>, ReviewsPlaceholderProps { }

export function ReviewsPlaceholder(props: StyledReviewsPlaceholderProps) {
    const { classes } = props;

    const renderCardPlaceholder = () => (
        <div className={classes.reviewCard}>
            <div className={classes.reviewHeader}>
                <div className={classes.circle}>
                    <SSRPlaceholder />
                </div>
                <div className={classes.title}>
                    <SSRPlaceholder />
                </div>
            </div>

            {range(4).map((index) => (
                <div className={classes.textLine} key={index}>
                        <SSRPlaceholder />
                </div>
            ))}
    </div>
    );

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <SSRPlaceholder />
            </div>
            <div className={classes.content}>
                <div className={classes.filters}>
                    <SSRPlaceholder />
                </div>
                <div className={classes.main}>
                    {renderCardPlaceholder()}
                    {renderCardPlaceholder()}
                </div>
            </div>
        </div>
    );
}
